var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnSmallExternal = function SvgIcnSmallExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.196 1.5h2.807a.5.5 0 0 1 .497.497v2.807a.5.5 0 0 1-.497.497.5.5 0 0 1-.497-.497V3.205L4.848 7.854a.495.495 0 0 1-.702 0 .494.494 0 0 1 0-.702l4.649-4.658H7.196a.5.5 0 0 1-.497-.497.5.5 0 0 1 .497-.497Zm1.298 5.08c0-.256.225-.466.498-.466a.5.5 0 0 1 .508.467v1.886c0 1.126-.977 2.033-2.168 2.033H3.669C2.466 10.5 1.5 9.584 1.5 8.467V5.033C1.5 3.907 2.477 3 3.668 3h2.003c.273 0 .498.21.498.467 0 .256-.225.467-.498.467H3.668c-.634 0-1.162.485-1.162 1.09v3.434c0 .595.518 1.09 1.163 1.09h3.663c.634 0 1.162-.486 1.162-1.09V6.58Z",
    fill: "#292525"
  })));
};
export default SvgIcnSmallExternal;